import React, { Component, useEffect, useState } from "react";
import Form from "../../comman/form";
import { Modal, Button } from "react-bootstrap";
import config from "../../config.json";
import auth, { getCurrentUser } from "../../services/authService";
import Joi from "joi-browser";
import { toast, cssTransition } from "react-toastify";
import Moment from "react-moment";
import useForm from "../../app/hooks/useForm";
import useControls from "../../app/hooks/useControls";
import { useDispatch, useSelector } from "react-redux";
import { addNewDuration, getAddedDurationObj, getAllDurations, getDurationAddedStatus, loadAllDurations } from "../../app/store/duration";
import { getMonthName } from "../../services/appService";
import moment from "moment";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";

const AddEditDuration = (props) => {
  const { editType, selectedObj, handleDurationShowHide, hideHeader } = props;

  const [durationHistory, setDurationHistory] = useState([]);
  const [extensionStatus, setExtensionStatus] = useState(null);
  const [durationEndDate, setDurationEndDate] = useState(null);
  const [compType, setCompType] = useState("");

  const allDurationsSelector = useSelector(getAllDurations);
  const durationAddedStatusSelector = useSelector(getDurationAddedStatus);

  const months = getMonthName();

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    if (selectedObj?.performerid > 0)
      dispatch(loadAllDurations(selectedObj.performerid));

    if (selectedObj?.duration?.endDate)
      setDurationEndDate(selectedObj.duration.endDate);
  }, []);

  useEffect(() => {
    if (allDurationsSelector.length > 0 && editType !== "") {
      setDurationHistory(allDurationsSelector);
      const terminatedDur = allDurationsSelector.filter(
        (x) => x.terminateStatus === true
      );
      if (terminatedDur.length > 0) {
        const trmDt = new Date(terminatedDur[0].terminateDate);
        stateData["terminateDate"] = moment(trmDt).format("MMM Do YYYY");
        stateData["notes"] = terminatedDur[0].notes;
        setStateData(stateData);
      }
      else {
        setStateData({});
      }
    }
  }, [allDurationsSelector, editType]);

  const handleRollbackTerminated = () => {
    // const { selectedObj } = this.props;
    // const { data } = await http.get(
    //   config.RollbackTerminatedCandidate + selectedObj.performerid
    // );
    // this.props.handleDurationChanges(data);
  };

  const schema = {};

  const doSubmit = async () => {
    setCompType("editDur")
    const data = { ...stateData };
    const newDate = moment(durationEndDate);
    newDate.add(parseInt(data["duration"]), 'M');

    const frmObj = {
      performerId: selectedObj.performerid,
      addedBy: currentUser.id,
      duration: data["duration"],
      durationState: extensionStatus,
      endDate: newDate.format("MM-DD-YYYY"),
      notes: data["notes"],
      startDate: selectedObj.duration?.startDate,
      terminateDate: moment(data["terminateDate"]).format("MM-DD-YYYY"),
    };
    //console.log(frmObj);
    const result = await getConfirmAlert("Warning", "Are you sure you want to Edit Duration?", "warning");
    if (result.isConfirmed)
      dispatch(addNewDuration(frmObj));
  };

  useEffect(() => {
    if (durationAddedStatusSelector && compType === "editDur") {
      getAlert("", "Duration saved Successfully", "success");
      setCompType("");
      if (selectedObj?.performerid > 0) dispatch(loadAllDurations(selectedObj.performerid));
      setExtensionStatus(null);
      setStateData(null);
      handleDurationShowHide("", "save", -1)
    }
  }, [durationAddedStatusSelector]);

  const { validate, handleChange, stateData, setStateData,
    stateErrors, setStateErrors, handleSubmit } = useForm(schema, doSubmit);

  const { renderSelect, renderInput, renderTextArea } = useControls(stateData, stateErrors, handleChange, schema);

  const handleExtensionChange = (value) => {
    setExtensionStatus(value);
  }

  if (stateData && parseInt(stateData["duration"]) > 0) {
    const newDate = moment(durationEndDate);
    newDate.add(parseInt(stateData["duration"]), 'M');
    //newDate.setMonth(newDate.getMonth() + parseInt(stateData["duration"]));
    stateData["endDate"] = newDate.format("MMM Do YYYY")
  }

  return (
    <React.Fragment>
      <style>{`
        /* ── Scoped Style for AddEditDuration ── */
        @keyframes aedFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── Header Section (Document Style) ── */
        .aed-header {
          display: flex; align-items: flex-start; justify-content: space-between;
          flex-wrap: wrap; gap: 18px; padding: 22px 24px 18px;
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
          border-bottom: 1px solid #f1f5f9; margin-bottom: 20px;
          border-radius: 12px 12px 0 0;
        }
        .aed-header-left { display: flex; align-items: flex-start; gap: 14px; flex: 1; }
        .aed-icon-box {
          width: 44px; height: 44px; border-radius: 12px;
          background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%);
          display: flex; align-items: center; justify-content: center;
          color: #ffffff; font-size: 18px; flex-shrink: 0;
          box-shadow: 0 8px 16px rgba(37, 99, 235, 0.2);
        }
        .aed-title-block { min-width: 0; }
        .aed-kicker {
          display: inline-flex; align-items: center; gap: 6px;
          margin: 0 0 5px; color: #2563eb; font-size: 11px;
          font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase;
        }
        .aed-title { font-size: 18px; font-weight: 800; color: #0f172a; margin: 0; line-height: 1.2; }
        .aed-subtitle { font-size: 13px; color: #64748b; margin: 6px 0 0; }
        
        /* ── wf-style input wrapper (from AddWorkflowPerformer) ── */
        .aed-wf-input-wrap { position: relative; width: 100%; }
        .aed-wf-input-icon {
          position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
          color: #94a3b8; font-size: 13px; pointer-events: none;
          transition: color 0.2s ease; z-index: 1;
        }
        .aed-wf-input-wrap:focus-within .aed-wf-input-icon { color: #2563eb; }

        /* Form Controls with Icon Spacing */
        .aed-field-group .form-control.has-icon {
          padding-left: 35px !important;
        }

        .aed-header-meta { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 12px; }
        .aed-header-right { display: flex; align-items: center; gap: 8px; margin-top: 4px; }
        .aed-meta-pill {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 4px 10px; border-radius: 99px; background: #ffffff;
          border: 1px solid #e2e8f0; color: #475569; font-size: 12px; font-weight: 700;
        }
        .aed-meta-pill i { font-size: 11px; }
        .aed-meta-pill.meta-id i { color: #1d4ed8; }
        .aed-meta-pill.meta-person i { color: #047857; }
        .aed-meta-pill.meta-email i { color: #0369a1; }
        .aed-meta-pill.meta-status-active i { color: #047857; }
        .aed-meta-pill.meta-status-inactive i { color: #dc2626; }

        .aed-container {
          animation: aedFadeIn 0.3s ease both;
          width: 100%;
          background: #ffffff;
          border: 1px solid rgba(226, 232, 240, 0.9);
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
          margin-bottom: 24px;
        }
        .aed-container.hide-inner-header .aed-header {
          display: none;
        }
        .aed-container.hide-inner-header .aed-content-body {
          padding-top: 24px;
        }
        .aed-content-body { padding: 0 24px 24px; }

        /* ── Selected Item Banner ── */
        .aed-banner {
          display: none; /* Hide old banner */
        }
        .aed-banner-icon {
          width: 38px; height: 38px; border-radius: 10px;
          background: rgba(99,102,241,0.08); color: #6366f1;
          display: flex; align-items: center; justify-content: center;
          font-size: 16px; flex-shrink: 0;
        }
        .aed-banner-text { display: flex; flex-direction: column; }
        .aed-banner-label { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.7px; }
        .aed-banner-value { font-size: 14.5px; font-weight: 800; color: #0f172a; margin-top: 1px; }

        /* ── Interactive Radio Cards ── */
        .aed-status-row { display: flex; gap: 12px; margin-bottom: 20px; flex-wrap: wrap; width: 100%; }
        .aed-radio-card {
          flex: 1; min-width: 160px; border: 2px solid #e2e8f0; border-radius: 11px;
          padding: 14px 16px; display: flex; align-items: center; gap: 12px;
          cursor: pointer; transition: all 0.25s ease; position: relative;
          background: #ffffff; user-select: none;
        }
        .aed-radio-card:hover {
          border-color: #cbd5e1; background: #f8fafc;
          transform: translateY(-1px); box-shadow: 0 4px 12px rgba(15,23,42,0.03);
        }
        .aed-radio-card-icon {
          width: 36px; height: 36px; border-radius: 9px;
          display: flex; align-items: center; justify-content: center;
          font-size: 15px; background: #f1f5f9; color: #64748b; transition: all 0.2s ease;
        }
        .aed-radio-card.extend-state.active {
          border-color: #2563eb; background: rgba(37, 99, 235, 0.02);
          box-shadow: 0 4px 16px rgba(37, 99, 235, 0.06);
        }
        .aed-radio-card.extend-state.active .aed-radio-card-icon {
          background: rgba(37, 99, 235, 0.1); color: #2563eb;
        }
        .aed-radio-card.terminate-state.active {
          border-color: #ef4444; background: rgba(239,68,68,0.02);
          box-shadow: 0 4px 16px rgba(239,68,68,0.06);
        }
        .aed-radio-card.terminate-state.active .aed-radio-card-icon {
          background: rgba(239,68,68,0.1); color: #dc2626;
        }
        .aed-radio-card-content { display: flex; flex-direction: column; text-align: left; }
        .aed-radio-card-title { font-size: 13px; font-weight: 700; color: #1e293b; }
        .aed-radio-card-desc { font-size: 11px; color: #64748b; margin-top: 2px; line-height: 1.3; }
        .aed-radio-card-badge {
          position: absolute; top: 12px; right: 12px;
          font-size: 15px; line-height: 1;
        }
        .aed-radio-card.extend-state.active .aed-radio-card-badge { color: #2563eb; }
        .aed-radio-card.terminate-state.active .aed-radio-card-badge { color: #ef4444; }

        /* ── Form Fields ── */
        .aed-field-group { margin-bottom: 18px; width: 100%; }
        .aed-field-group label,
        .aed-notes-group label {
          font-size: 11px; font-weight: 700; color: #64748b;
          text-transform: uppercase; letter-spacing: 0.7px; margin-bottom: 6px;
          display: flex; align-items: center; gap: 5px;
        }
        .aed-field-group label i,
        .aed-notes-group label i { color: #94a3b8; font-size: 11px; }

        .aed-field-group .form-control {
          border-radius: 9px !important; border: 1.5px solid #e2e8f0 !important;
          padding: 10px 14px !important; font-size: 13px !important;
          color: #1e293b !important; background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
          box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03) !important;
        }
        .aed-field-group .form-control:hover {
          border-color: #94a3b8 !important; box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
        }
        .aed-field-group .form-control:focus {
          border-color: #6366f1 !important;
          box-shadow: 0 0 0 4px rgba(99,102,241,0.1), 0 2px 6px -1px rgba(99,102,241,0.08) !important;
          outline: none !important; background: #fafbff !important;
        }
        .aed-field-group .form-control:disabled {
          background: #f8fafc !important; color: #94a3b8 !important;
          cursor: not-allowed !important;
        }

        /* ── Notes Block ── */
        .aed-notes-group { margin-bottom: 22px; width: 100%; }
        .aed-notes-group textarea {
          border-radius: 9px !important; border: 1.5px solid #e2e8f0 !important;
          padding: 10px 14px !important; font-size: 13px !important;
          color: #1e293b !important; background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
          box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03) !important;
          resize: vertical !important; min-height: 70px;
        }
        .aed-notes-group textarea:hover {
          border-color: #94a3b8 !important; box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
        }
        .aed-notes-group textarea:focus {
          border-color: #6366f1 !important;
          box-shadow: 0 0 0 4px rgba(99,102,241,0.1), 0 2px 6px -1px rgba(99,102,241,0.08) !important;
          outline: none !important; background: #fafbff !important;
        }

        /* ── Action Buttons ── */
        .aed-submit-btn {
          min-height: 38px; display: inline-flex; align-items: center; justify-content: center;
          gap: 8px; font-size: 13px; font-weight: 600; border-radius: 8px;
          cursor: pointer; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          padding: 8px 24px; border: 1px solid transparent; outline: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          background: #2563eb; color: white;
        }
        .aed-submit-btn:hover {
          background: #1d4ed8; transform: translateY(-1px);
          box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.12);
        }

        .aed-cancel-btn {
          min-height: 38px; display: inline-flex; align-items: center; justify-content: center;
          gap: 8px; font-size: 13px; font-weight: 600; border-radius: 8px;
          cursor: pointer; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          padding: 8px 16px; border: 1.5px solid #cbd5e1; outline: none;
          background: #ffffff; color: #475569;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }
        .aed-cancel-btn:hover {
          background: #f8fafc; border-color: #94a3b8; color: #1e293b;
          transform: translateY(-1px);
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
        }

        .aed-rollback-btn {
          min-height: 38px; display: inline-flex; align-items: center; justify-content: center;
          gap: 8px; font-size: 13px; font-weight: 600; border-radius: 8px;
          cursor: pointer; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          padding: 8px 24px; border: 1px solid transparent; outline: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          background: #f59e0b; color: white;
        }
        .aed-rollback-btn:hover {
          background: #d97706; transform: translateY(-1px);
          box-shadow: 0 10px 15px -3px rgba(245,158,11,0.12);
        }

        /* ── History Table Styling ── */
        .aed-history-title {
          font-size: 11px; font-weight: 700; color: #64748b;
          text-transform: uppercase; letter-spacing: 0.7px; margin-top: 0; margin-bottom: 12px;
          display: flex; align-items: center; gap: 6px; width: 100%;
        }
        .aed-history-title i { color: #94a3b8; font-size: 12px; }
        .aed-history-count {
          display: inline-flex; align-items: center; justify-content: center;
          min-width: 20px; height: 20px; padding: 0 6px;
          border-radius: 20px; background: #2563eb; color: #fff;
          font-size: 10px; font-weight: 700;
        }

        .aed-table {
          width: 100% !important; border-collapse: separate !important; border-spacing: 0 2px !important;
        }
        .aed-thead th {
          background: #f8fafc !important; color: #475569 !important; font-size: 10.5px !important;
          font-weight: 700 !important; text-transform: uppercase !important; letter-spacing: 0.8px !important;
          padding: 10px 16px !important; border: none !important; border-bottom: 2px solid #e2e8f0 !important;
        }
        .aed-table-row {
          background: #ffffff !important; transition: all 0.2s ease !important;
        }
        .aed-table-row:hover {
          background: #f8fafc !important;
        }
        .aed-table-row td {
          padding: 10px 16px !important; font-size: 13px !important; color: #334155 !important;
          border: none !important; border-bottom: 1px solid #f1f5f9 !important; vertical-align: middle !important;
        }

        /* Badge Capsules */
        .aed-badge-capsule {
          display: inline-flex; align-items: center; gap: 5px;
          padding: 3px 10px; border-radius: 99px; font-size: 11px; font-weight: 700;
          line-height: 1; text-transform: uppercase; letter-spacing: 0.5px;
        }
        .aed-badge-capsule i { font-size: 10px; }
        .aed-badge-capsule.badge-extended {
          background: rgba(37, 99, 235, 0.08) !important; color: #2563eb !important;
          border: 1px solid rgba(37, 99, 235, 0.15) !important;
        }
        .aed-badge-capsule.badge-not-extend {
          background: rgba(239,68,68,0.08) !important; color: #dc2626 !important;
          border: 1px solid rgba(239,68,68,0.15) !important;
        }

        /* ── Split Grid Columns Styling ── */
        @media (min-width: 992px) {
          .aed-left-col {
            border-right: 1px solid #f1f5f9;
            padding-right: 28px;
          }
          .aed-right-col {
            padding-left: 28px;
          }
        }
      `}</style>

      {editType !== "" && stateData && (
        <div className={`aed-container mt-2${hideHeader ? " hide-inner-header" : ""}`}>

          {/* ═══ HEADER SECTION ═══ */}
          <div className="aed-header">
            <div className="aed-header-left">
              <div className="aed-icon-box">
                <i className={`fa ${editType === "terminated" ? "fa-calendar-times-o" : "fa-hourglass-half"}`} />
              </div>
              <div className="aed-title-block">
                <h2 className="aed-title">Duration Details</h2>
                <p className="aed-subtitle">
                  Review and manage contract terms for {selectedObj?.performername} {selectedObj?.lastName}.
                </p>

                <div className="aed-header-meta">
                  <span className="aed-meta-pill meta-id">
                    <i className="fa fa-id-badge" /> ID: {selectedObj?.performerid}
                  </span>
                  <span className="aed-meta-pill meta-person">
                    <i className="fa fa-user" /> {selectedObj?.performername} {selectedObj?.lastName}
                  </span>
                  {selectedObj?.performeremail && (
                    <span className="aed-meta-pill meta-email">
                      <i className="fa fa-envelope-o" /> {selectedObj.performeremail}
                    </span>
                  )}
                  <span className={`aed-meta-pill ${selectedObj?.duration?.terminateStatus ? "meta-status-inactive" : "meta-status-active"}`}>
                    <i className="fa fa-circle" /> Status: {selectedObj?.duration?.terminateStatus ? "Terminated" : "Active"}
                  </span>
                </div>
              </div>
            </div>

            <div className="aed-header-right">
              <button
                type="button"
                className="aed-cancel-btn mr-2"
                onClick={() => {
                  if (selectedObj?.performerid > 0)
                    dispatch(loadAllDurations(selectedObj.performerid));
                }}
                title="Refresh Duration History"
              >
                <i className="fa fa-refresh" /> Refresh
              </button>
              <button
                type="button"
                className="aed-cancel-btn"
                onClick={() => handleDurationShowHide("", "", -1)}
              >
                <i className="fa fa-arrow-left" /> Back
              </button>
            </div>
          </div>

          <div className="aed-content-body">
            <div className="row">

              {/* Left Column: Duration Form */}
              <div className="col-lg-5 col-md-12 aed-left-col">

                {/* Selected Candidate Banner (Hidden via CSS, but keeping structure for safety) */}
                <div className="aed-banner">
                  <div className="aed-banner-icon">
                    <i className="fa fa-clock-o" />
                  </div>
                  <div className="aed-banner-text">
                    <span className="aed-banner-label">Edit Duration</span>
                    <strong className="aed-banner-value">
                      {selectedObj?.performername} {selectedObj?.lastName}
                    </strong>
                  </div>
                </div>

                {editType === "duration" && (
                  <React.Fragment>
                    {/* Interactive Radio Cards */}
                    <div className="aed-status-row">
                      <div
                        className={`aed-radio-card extend-state${extensionStatus === true ? " active" : ""}`}
                        onClick={() => handleExtensionChange(true)}
                        role="button" tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && handleExtensionChange(true)}
                      >
                        <div className="aed-radio-card-icon"><i className="fa fa-calendar-plus-o" /></div>
                        <div className="aed-radio-card-content">
                          <span className="aed-radio-card-title">Extend</span>
                          <span className="aed-radio-card-desc">Extend the contract duration</span>
                        </div>
                        {extensionStatus === true && (
                          <div className="aed-radio-card-badge"><i className="fa fa-check-circle" /></div>
                        )}
                      </div>

                      <div
                        className={`aed-radio-card terminate-state${extensionStatus === false ? " active" : ""}`}
                        onClick={() => handleExtensionChange(false)}
                        role="button" tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && handleExtensionChange(false)}
                      >
                        <div className="aed-radio-card-icon"><i className="fa fa-calendar-times-o" /></div>
                        <div className="aed-radio-card-content">
                          <span className="aed-radio-card-title">Do Not Extend</span>
                          <span className="aed-radio-card-desc">Terminate the contract</span>
                        </div>
                        {extensionStatus === false && (
                          <div className="aed-radio-card-badge"><i className="fa fa-check-circle" /></div>
                        )}
                      </div>
                    </div>

                    {/* Duration + End Date fields (when extending) */}
                    {extensionStatus && (
                      <div className="row">
                        <div className="col-md-6 aed-field-group">
                          <label className="form-control-label" htmlFor="duration">
                            <i className="fa fa-hourglass-start" /> Duration (In Month)
                          </label>
                          <div className="aed-wf-input-wrap">
                            <i className="fa fa-clock-o aed-wf-input-icon" aria-hidden="true" />
                            <input
                              type="number"
                              id="duration"
                              name="duration"
                              className="form-control has-icon"
                              value={stateData.duration || ""}
                              onChange={handleChange}
                              placeholder="Duration"
                            />
                          </div>
                          {stateErrors.duration && <div className="alert alert-danger">{stateErrors.duration}</div>}
                        </div>
                        <div className="col-md-6 aed-field-group">
                          <label className="form-control-label" htmlFor="endDate">
                            <i className="fa fa-calendar-check-o" /> End Date
                          </label>
                          <div className="aed-wf-input-wrap">
                            <i className="fa fa-calendar aed-wf-input-icon" aria-hidden="true" />
                            <input
                              type="text"
                              id="endDate"
                              name="endDate"
                              className="form-control has-icon"
                              value={stateData.endDate || ""}
                              disabled={true}
                              placeholder="End Date"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Terminate date (when not extending) */}
                    {extensionStatus === false && (
                      <div className="aed-field-group">
                        <label className="form-control-label" htmlFor="terminateDate">
                          <i className="fa fa-calendar-times-o" /> Terminate Date
                        </label>
                        <div className="aed-wf-input-wrap">
                          <i className="fa fa-calendar aed-wf-input-icon" aria-hidden="true" />
                          <input
                            type="date"
                            id="terminateDate"
                            name="terminateDate"
                            className="form-control has-icon"
                            value={stateData.terminateDate || ""}
                            onChange={handleChange}
                          />
                        </div>
                        {stateErrors.terminateDate && <div className="alert alert-danger">{stateErrors.terminateDate}</div>}
                      </div>
                    )}
                  </React.Fragment>
                )}

                {editType === "terminated" && (
                  <div className="aed-field-group">
                    <label className="form-control-label" htmlFor="terminateDate">
                      <i className="fa fa-calendar-times-o" /> Terminate Date
                    </label>
                    <div className="aed-wf-input-wrap">
                      <i className="fa fa-calendar aed-wf-input-icon" aria-hidden="true" />
                      <input
                        type="date"
                        id="terminateDate"
                        name="terminateDate"
                        className="form-control has-icon"
                        value={stateData.terminateDate || ""}
                        onChange={handleChange}
                      />
                    </div>
                    {stateErrors.terminateDate && <div className="alert alert-danger">{stateErrors.terminateDate}</div>}
                  </div>
                )}

                {/* Notes */}
                <div className="aed-notes-group">
                  <label className="form-control-label" htmlFor="notes">
                    <i className="fa fa-sticky-note-o" /> Notes
                  </label>
                  {renderTextArea("notes", "")}
                </div>

                {/* Actions */}
                <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginBottom: "20px" }}>
                  <button
                    type="button"
                    className="aed-cancel-btn"
                    onClick={() => handleDurationShowHide("", "", -1)}
                  >
                    <i className="fa fa-arrow-left" aria-hidden="true" /> Back
                  </button>

                  {editType !== "terminated" && (
                    <button
                      type="button"
                      className="aed-submit-btn"
                      onClick={handleSubmit}
                    >
                      <i className="fa fa-check" aria-hidden="true" /> Save
                    </button>
                  )}

                  {editType === "terminated" && (
                    <button
                      type="button"
                      className="aed-rollback-btn"
                    //onClick={handleRollbackTerminated}
                    >
                      <i className="fa fa-undo" aria-hidden="true" /> Rollback Termination
                    </button>
                  )}
                </div>
              </div>

              {/* Right Column: Duration History Log */}
              <div className="col-lg-7 col-md-12 aed-right-col">
                {editType === "duration" && (
                  <>
                    <div className="aed-history-title">
                      <i className="fa fa-history" />
                      <span>Duration History</span>
                      {durationHistory.length > 0 && (
                        <span className="aed-history-count">{durationHistory.length}</span>
                      )}
                    </div>

                    <div className="table-responsive" style={{ border: "1px solid #e2e8f0", borderRadius: "12px", overflow: "auto" }}>
                      <table className="table aed-table m-0">
                        <thead className="aed-thead">
                          <tr>
                            <th style={{ width: "60px", textAlign: "center" }}>S.No.</th>
                            <th>Date & Time Added</th>
                            <th style={{ width: "130px" }}>Status</th>
                            <th>Duration</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th style={{ minWidth: "150px" }}>Notes</th>
                          </tr>
                        </thead>
                        <tbody>
                          {durationHistory.length === 0 ? (
                            <tr className="aed-table-row">
                              <td colSpan={7} className="text-center py-4 text-muted" style={{ fontSize: "12.5px" }}>
                                <i className="fa fa-info-circle mr-1" /> No duration history records found.
                              </td>
                            </tr>
                          ) : (
                            durationHistory.map((item, key) => (
                              <tr key={`dur-history-${key}`} className="aed-table-row">
                                <td className="text-center font-weight-bold" style={{ color: "#64748b" }}>{key + 1}</td>
                                <td style={{ whiteSpace: "nowrap" }}>
                                  <Moment format="MMM Do YYYY, h:mm a">
                                    {item.addedDateTime}
                                  </Moment>
                                </td>
                                <td>
                                  {item.durationState ? (
                                    <span className="aed-badge-capsule badge-extended">
                                      <i className="fa fa-check" aria-hidden="true" />
                                      Extended
                                    </span>
                                  ) : (
                                    <span className="aed-badge-capsule badge-not-extend">
                                      <i className="fa fa-times" aria-hidden="true" />
                                      Not Extend
                                    </span>
                                  )}
                                </td>
                                <td>{item.duration} Months</td>
                                <td style={{ whiteSpace: "nowrap" }}>
                                  <Moment format="MMM Do YYYY">{item.startDate}</Moment>
                                </td>
                                <td style={{ whiteSpace: "nowrap" }}>
                                  <Moment format="MMM Do YYYY">{item.endDate}</Moment>
                                </td>
                                <td>{item.notes || <span className="text-muted" style={{ fontStyle: "italic" }}>— No notes —</span>}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>

            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default AddEditDuration;
